import { useDispatch } from "react-redux";
import { EMPTY_RECORD, useDetailRecord } from 'helpers/detailRequest';
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import LeadDetailHeader from "./detail/LeadDetailHeader";
import { Badge, Card, Tabs, DetailRecordFallback } from 'components/common';
import { MdHistory } from "react-icons/md";
import { FaLeaf, FaRegListAlt, FaUser } from "react-icons/fa";
import { getLead } from "redux/crm/leadSlice";
import LeadStep from "./detail/LeadStep";
import LeadActivity from "./detail/LeadActivity";
import RatingScore from "./component/RatingScore";
import useBreadcrumb from "hooks/useBreadcrumb";

const LeadDetail = () => {
  const dispatch = useDispatch();
  const params = useParams();
  // Only the record in the URL — the persisted store can still hold the one
  // viewed last (e.g. when opened from an email link).
  const { record, waiting, error } = useDetailRecord('crm_lead', params.id);
  const lead = record || EMPTY_RECORD;

  // Breadcrumb: hiển thị tên lead thay vì id
  useBreadcrumb(
    lead
      ? [
          { label: 'Leads', to: '/crm/leads/list' },
          { label: lead.name || `Lead ${params.id}` }
        ]
      : null
  );

  const status = lead?.status

  useEffect(() => {
    dispatch(getLead(params.id))
  }, [params, dispatch])

  if (!record) return <DetailRecordFallback waiting={waiting} title="Lead not available" error={error} onRetry={() => dispatch(getLead(params.id))} />;

  return (
    <>
      <LeadDetailHeader lead={lead} />

      <Card className="tw-mb-3" padding="lg">
        <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-text-sm">
          <div className="tw-col-span-12 sm:tw-col-span-6">
            <div>
              <FaLeaf />
              <span className="tw-text-lg tw-font-semibold tw-text-blue-600 tw-ml-1">{lead?.name}</span>
            </div>
            <div>Status: <Badge variant="primary" size="sm">{status?.name}</Badge> / <Badge variant="info" size="sm">{lead.stage}</Badge> / <span className="tw-text-blue-600">{lead.mql_status}</span> / Rating: <RatingScore rating={lead.rating} /> </div>
            <div className="tw-text-xs">Created by: <strong>{lead.created_by}</strong>, Date: {lead.created_date}</div>
          </div>
          <div className="tw-col-span-12 sm:tw-col-span-4">
            Account name:
            <div className="tw-text-blue-600 tw-mt-1 tw-text-sm">{lead.account_name}</div>
          </div>
          <div className="tw-col-span-12 sm:tw-col-span-2">
            <FaUser /> Owner:
            <div className="tw-text-blue-600 tw-font-bold tw-mt-1 tw-text-sm">{lead.owner_by}</div>
          </div>
        </div>
      </Card>

      <Card padding="none">
        <Tabs
          variant="underline"
          lazyMount
          navClassName="tw-px-3 tw-pt-2 tw-bg-white"
          contentClassName="tw-bg-slate-50 tw-p-4"
          tabs={[
            {
              label: 'Detail',
              icon: <FaRegListAlt size={14} />,
              content: <LeadStep lead={lead} />,
            },
            {
              label: 'Activities',
              icon: <MdHistory size={14} />,
              content: <LeadActivity lead={lead} />,
            },
          ]}
        />
      </Card>
    </>
  )
}

export default LeadDetail;
